import handleCallback from "../helper/APICallback";
import APIService from "../services/apiService";
import AuthService from "../services/authService";
import ObjectToQueryParams from "../services/ObjectToQueryParams";
const API = AuthService.getRemoteURL();
const rootRoute = "/api/v1/POS";
export const path = {
  rootRoute,
  tableQR: {
    table: {
      details: `${rootRoute}/merchant/on-table/getTableDetails`,
    },
    orders: {
      list: `${rootRoute}/merchant/on-table/prev-orders`,
      placeOrder: `${rootRoute}/merchant/on-table/staff/append-table-orders`,
    },
  },
  scanQR: {
    categories: {
      list: `${rootRoute}/merchant/on-table/getParentWithCounter`,
    },
    subCategories: {
      list: `${rootRoute}/merchant/on-table/getAllSubCategories`,
    },
    products: {
      list: `${rootRoute}/merchant/on-table/getAllProducts`,
    },
    location: {
      suggestions: `${rootRoute}/merchant/on-table/getAddressSuggestions`,
      details: `${rootRoute}/merchant/on-table/getAddressFromPlaceId`,
      detailsFromLatLong: `${rootRoute}/merchant/on-table/getAddressFromLatLong`,
    },
  },
};

export const fetcher = (args) => {
  const [url, config, customHeaders] = Array.isArray(args) ? args : [args];
  return new Promise((resolve, reject) => {
    APIService.request(
      {
        url: `${API}${url}${ObjectToQueryParams(config?.params)}`,
        method: "GET",
      },
      handleCallback(resolve, reject)
    );
  });
};
